import styles from './Loader.module.css';

const Loader = () => {
  return <div className={styles['lds-hourglass']}></div>;
};

export default Loader;
